import { Modal, ModalType } from '@app/modules/modal-container/models/modal.model'

export const calibrationTemplateSelectionModalObject = {
    title: 'SELECT TEMPLATE',
    icon: 'gauge',
    footer: false,
    close: true,
    type: ModalType.CalibrationTemplateSelection
} as Modal
